type CustomBorderIconProps = React.SVGProps<SVGSVGElement> & {
    style?: React.CSSProperties
}

const BorderOnlyBottomIcon = ({ style = {}, ...otherProps }: CustomBorderIconProps) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 257 257'
        fill='currentColor'
        style={{
            display: 'inline-block',
            flexShrink: 0,
            ...style
        }}
        {...otherProps}>

        <rect className='st0' x='203.45' y='160.59' width='21.42' height='21.42' />
        <rect className='st0' x='32.11' y='160.59' width='21.42' height='21.42' />
        <rect className='st0' x='117.78' y='160.59' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='117.76' width='21.42' height='21.42' />
        <rect className='st0' x='160.6' y='117.76' width='21.42' height='21.42' />
        <rect className='st0' x='117.78' y='74.93' width='21.42' height='21.42' />
        <path className='st0' d='M42.82,224.88h171.33c5.89,0,10.71-4.82,10.71-10.71s-4.82-10.71-10.71-10.71H42.82c-5.89,0-10.71,4.82-10.71,10.71s4.82,10.71,10.71,10.71Z' />
        <rect className='st0' x='203.45' y='74.93' width='21.42' height='21.42' />
        <rect className='st0' x='32.11' y='74.93' width='21.42' height='21.42' />
        <rect className='st0' x='117.78' y='117.76' width='21.42' height='21.42' />
        <rect className='st0' x='32.11' y='117.76' width='21.42' height='21.42' />
        <rect className='st0' x='74.95' y='117.76' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='32.1' width='21.42' height='21.42' />
        <rect className='st0' x='160.6' y='32.1' width='21.42' height='21.42' />
        <rect className='st0' x='117.78' y='32.1' width='21.42' height='21.42' />
        <rect className='st0' x='32.11' y='32.1' width='21.42' height='21.42' />
        <rect className='st0' x='74.95' y='32.1' width='21.42' height='21.42' />
    </svg>
)

export default BorderOnlyBottomIcon
